import apiClient from './client';

export const settingsService = {
  getSetting: async (key: string): Promise<{ success: boolean; data: { key: string; value: string | null } }> => {
    const res = await apiClient.get(`/admin/settings/${key}`);
    return res.data;
  },

  setSetting: async (key: string, value: string): Promise<{ success: boolean; data: { key: string; value: string | null } }> => {
    const res = await apiClient.put(`/admin/settings/${key}`, { value });
    return res.data;
  },
};
